module.exports = __webpack_public_path__ + "img/74_31.63975e18.png";